'use strict';

const canvasCourseAvailability = require('./canvasCourseAvailability');

angular.module('client.services').factory('canvasService', ['$resource', '$q', 'CourseFactory', '$log', 'User', 'api_server',
  function ($resource, $q, CourseFactory, $log, User, api_server) {

    var imsResource = $resource(api_server + '/users/:id/ims', {id: '@id'},
      {
        'get': {method: 'GET', isArray: true}
      });

    function getIms(id) {
      return imsResource.get({id: id}).$promise;
    }

    var coursesResource = $resource(api_server + '/ims/courses/list', {ims_id: '@ims_id'},
      {
        'get': {method: 'GET', isArray: true}
      });

    function getCourses(ims_id) {
      return coursesResource.get({ims_id: ims_id}).$promise;
    }

    var studentsResource = $resource(api_server + '/ims/courses/:id/students', {
        id: '@id',
        ims_id: '@ims_id',
        section_id: '@section_id'
      },
      {
        'get': {method: 'GET', isArray: true}
      });

    function getStudents(ims_id, section_id, id) {
      return studentsResource.get({id: id, ims_id: ims_id, section_id: section_id}).$promise;
    }

    var courseResource = $resource(api_server + '/ims/courses/course/:id', {id: '@id'},
      {
        'get': {method: 'GET'}
      });

    function getCourse(id) {
      return courseResource.get({id: id}).$promise;
    }

    var importResource = $resource(api_server + '/ims/courses/import/:id', {id: '@id'},
      {
        'post': {method: 'POST'}
      });

    function importCourse(id, params) {
      return importResource.post({id: id}, params).$promise;
    }

    var syncResource = $resource(api_server + '/ims/courses/sync', {ims_id: '@ims_id'},
      {
        'post': {method: 'POST'}
      });

    function syncCourse(ims_id, id) {
      return syncResource.post({ims_id: ims_id}, {cid: id}).$promise;
    }

    var assignmentResource = $resource(api_server + '/ims/assignment/:experience_id', {
        experience_id: '@experience_id',
        ims_id: '@ims_id'
      },
      {
        'post': {method: 'POST'}
      });

    function postAssignment(ims_id, experience_id) {
      return assignmentResource.post({experience_id: experience_id, ims_id: ims_id}).$promise;
    }

    function getAvailableCourses(user) {
      var canvasClasses = {
        courses: [],
        fetched: false,
        hasCanvasCourses: false,
        loadFailed: false,
        partiallyLoaded: false
      };

      // if this user is NOT a canvas user then immediately return an empty list
      if (!user.canvas_user) {
        return $q.when(canvasClasses);
      }

      return getIms(user.id).then(function (response) {
        // If the current user is not an IMS(canvas) user then return empty list
        if (!response || !response.length) {
          return Object.assign({}, canvasClasses, {loadFailed: true});
        }

        const integrationIds = canvasCourseAvailability.getCanvasIntegrationIds(response);
        if (!integrationIds.length) {
          return Object.assign({}, canvasClasses, {loadFailed: true});
        }

        const courseRequests = integrationIds.map(function (integrationId) {
          return getCourses(integrationId).then(function (canvasCourses) {
            return {
              integrationId: integrationId,
              courses: canvasCourses || [],
              succeeded: true
            };
          }, function (error) {
            $log.error("canvas API error for integration " + integrationId + ":", error);
            return {
              integrationId: integrationId,
              courses: [],
              succeeded: false
            };
          });
        });

        return $q.all(courseRequests).then(function (courseResults) {
          // Look up this teacher's existing classes once, then filter each Canvas district independently.
          var params = {teacher_user_id: User.getId()};
          return CourseFactory.list(params).then(function (courses) {
            return canvasCourseAvailability.createAvailableCanvasClasses(courseResults, courses);
          }, function (error) {
            $log.error("canvas API error:", error);
            return $q.reject(error);
          });
        });
      })
        .catch(function (error) {
          $log.error("get classroom API error:", error);
          return Object.assign({}, canvasClasses, {loadFailed: true});
        });
    }

    var linkResource = $resource(api_server + '/ims/courses/link', {ims_id: '@ims_id'},
      {
        'post': {method: 'POST'}
      });

    function linkCourse(user, cid, className, courseId, sectionId, settings, selectedIntegrationId) {
      return getIms(user.id).then(function (response) {
        if (!response || !response.length) {
          return null;
        }
        const integrationId = canvasCourseAvailability.getCanvasLinkIntegrationId(
          response,
          selectedIntegrationId
        );
        if (!integrationId) {
          return null;
        }
        return linkResource.post({ims_id: integrationId}, {
          cid: cid,
          className: className,
          courseId: courseId,
          sectionId: sectionId,
          settings: settings
        }).$promise;
      });
    }

    return {
      getCourses: getCourses,
      getStudents: getStudents,
      getCourse: getCourse,
      importCourse: importCourse,
      syncCourse: syncCourse,
      postAssignment: postAssignment,
      getAvailableCourses: getAvailableCourses,
      linkCourse: linkCourse
    };
  }]);
